import type { ReactNode } from 'react';
import { useEffect, useId } from 'react';
import { IconeFechar } from './Icones.js';
import './PainelLateral.css';

type Props = {
  readonly titulo: ReactNode;
  /** Linha de metadados sob o título (operador, início, duração, procedência). */
  readonly subtitulo?: ReactNode;
  readonly acoes?: ReactNode;
  readonly rodape?: ReactNode;
  readonly aoFechar: () => void;
  readonly children: ReactNode;
};

/**
 * Painel deslizante à direita, sobre a listagem.
 *
 * O supervisor não perde a tabela de vista ao abrir um registro — por isso o
 * detalhe é painel, não navegação. Fecha no Esc e no clique fora, como todo
 * diálogo modal.
 */
export function PainelLateral({ titulo, subtitulo, acoes, rodape, aoFechar, children }: Props) {
  const idTitulo = useId();

  useEffect(() => {
    function aoTeclar(evento: KeyboardEvent) {
      if (evento.key === 'Escape') {
        aoFechar();
      }
    }

    document.addEventListener('keydown', aoTeclar);
    return () => {
      document.removeEventListener('keydown', aoTeclar);
    };
  }, [aoFechar]);

  return (
    <div className="painel-lateral">
      <div
        className="painel-lateral__veu"
        role="presentation"
        onClick={() => {
          aoFechar();
        }}
      />
      <aside
        className="painel-lateral__caixa"
        role="dialog"
        aria-modal="true"
        aria-labelledby={idTitulo}
      >
        <div className="painel-lateral__cabecalho">
          <div className="painel-lateral__identidade">
            <div className="painel-lateral__titulo" id={idTitulo}>
              {titulo}
            </div>
            {subtitulo !== undefined && (
              <div className="painel-lateral__subtitulo">{subtitulo}</div>
            )}
          </div>
          <div className="painel-lateral__acoes">
            {acoes}
            <button
              type="button"
              className="painel-lateral__fechar"
              aria-label="Fechar detalhe"
              onClick={() => {
                aoFechar();
              }}
            >
              <IconeFechar tamanho={17} />
            </button>
          </div>
        </div>

        <div className="painel-lateral__corpo">{children}</div>

        {rodape !== undefined && <div className="painel-lateral__rodape">{rodape}</div>}
      </aside>
    </div>
  );
}
